import { CircleHelp } from "lucide-react";
import { useCurrentTourTitle, useTour } from "@/lib/tours/TourContext";

export function TourHelpButton() {
  const { currentTourId, startCurrentPageTour } = useTour();
  const tourTitle = useCurrentTourTitle();

  if (!currentTourId) return null;

  return (
    <button
      type="button"
      data-tour="tour-help"
      onClick={() => startCurrentPageTour({ force: true })}
      className="flex min-h-[2.5rem] min-w-[2.5rem] items-center justify-center rounded-lg text-label-secondary transition hover:bg-fill hover:text-label"
      aria-label={tourTitle ? `Hilfe: ${tourTitle}` : "Seitenhilfe starten"}
      title={tourTitle ? `Tour: ${tourTitle}` : "Hilfe"}
    >
      <CircleHelp size={20} strokeWidth={1.75} aria-hidden />
    </button>
  );
}
